const globalData = require('./globalDataFactory');
const originalError = console.error;

console.warn = (...args) => {
	const msg = args[0];
	const isNoise = typeof msg === 'string' && (
		msg.includes('Each child in a list should have a unique "key" prop') ||
		msg.includes('validateDOMNesting') ||
		msg.includes('deprecated')
	);
	if (isNoise) return;
};
console.error = (...args) => {
	const msg = args[0];

	// Target the specific "key" and "nesting" strings used by React 16
	const isNoise = typeof msg === 'string' && (
		msg.includes('Each child in a list should have a unique "key" prop') ||
      msg.includes('validateDOMNesting') ||
      msg.includes('deprecated')
	);

	if (isNoise) return;

	originalError.apply(console, args);
};

const getConsulData = (key) => {
	if (typeof global !== 'undefined') {
		const consulDataJSON = (global.consulData) || {};
		return (consulDataJSON[key] || {});
	}
	if (typeof window !== 'undefined') {
		const consulData = globalData.getProperty('consulData') || globalData.setProperty('consulData', window.consulData) || window.consulData;
		if (consulData) {
			return key ? consulData[key] : consulData;
		}
	}
	return {};
};

const isChatBotEnabled = (orgId, uuid) => {
	try {
		const consulData = getConsulData('config').CHAT_BOT || {};
		const enableConfig = consulData.ENABLED_CONFIG || {};
		const chatBotEnabled = enableConfig['all'] || enableConfig[orgId]?.includes(uuid) || enableConfig[orgId]?.length == 0;
		return chatBotEnabled;
	} catch (error) {
		return false;
	}
};

const setProfileData = (empDetails) => {
	const profileData = {};
	if (empDetails) {
		const { organizationId, name = '', id, businessEmailId, employeeStatus, phoneNumber, roles = [], gender, title,
			mmtUserId = '', mmtUuid = '', rolePermissions } = empDetails;
		profileData.name = name;
		profileData.id = id;
		profileData.email = businessEmailId;
		profileData.status = employeeStatus;
		profileData.phone = phoneNumber;
		profileData.gender = gender;
		profileData.firstLetter = name && name[0] ? name[0].toUpperCase() : '';
		profileData.title = title;
		profileData.isAdmin = roles && roles.length > 0 && roles.includes('Admin');
		profileData.mmtUuid = mmtUuid;
		profileData.orgId = organizationId;
		profileData.rolePermissions = rolePermissions;

		try {
			if (typeof window !== 'undefined') {
				globalData.setProperty('profileData', profileData);
				localStorage.setItem('mmtUserId', mmtUserId);
			}

			if (typeof global !== 'undefined') {
				global.profileData = profileData;
			}
		} catch (error) {
		}
	}
	return profileData;
};

const getProfileDataProps = (prop) => {
	try {
		let profileData = {};
		if (typeof global !== 'undefined') {
			profileData = global.profileData;
		}
		if (typeof window !== 'undefined') {
			profileData = globalData.getProperty('profileData');
		}
		return profileData?.[prop];
	} catch (err) {
		return false;
	}
};

module.exports = { getConsulData, isChatBotEnabled, setProfileData, getProfileDataProps };
